import { PropsWithChildren, SyntheticEvent, type JSX } from "react";

/** @returns a component that will stop the propagation of mouse and pointer events */
export function EventBarrier({ children }: PropsWithChildren): JSX.Element {
  return (
    <div
      onPointerDown={stopPropagation}
      onPointerUp={stopPropagation}
      onPointerMove={stopPropagation}
      onMouseDown={stopPropagation}
      onMouseUp={stopPropagation}
      onMouseMove={stopPropagation}
      onWheel={stopPropagation}
      onClick={stopPropagation}
      onDoubleClick={stopPropagation}
      onContextMenu={stopPropagation}
    >
      {children}
    </div>
  );
}

/**
 * A generic event handler to stop the propagation of that event
 *
 * @param event to stop the propagation of
 */
function stopPropagation(event: SyntheticEvent): void {
  event.stopPropagation();
  // Stopping the propagation immediately, to make sure any sibling elements also don't get the events.
  event.nativeEvent.stopImmediatePropagation();
}
